import React from 'react';
import Grid from 'tradevan-ui/Grid';

export const FormGrid = (props: {
  title: React.ReactNode;
  children: React.ReactNode;
  titleMd?: number;
  contentMd?: number;
}) => {
  const { children, title, titleMd = 2, contentMd = 3 } = props;

  return (
    <Grid row style={{ margin: '0.75rem 0' }}>
      <Grid
        col
        md={titleMd}
        style={{
          display: 'flex',
          justifyContent: 'right',
          paddingRight: '0.5rem',
          alignItems: 'center',
        }}
      >
        {title}
      </Grid>
      <Grid col md={contentMd}>
        {children}
      </Grid>
    </Grid>
  );
};
export default FormGrid;
